<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.147 12.6586L19.0588 3L20.3824 9.33141L18.5817 11.6249L21 14.3061L12 21L3 14.3061L5.41831 11.6249L3.61765 9.33141L4.94118 3L8.85295 12.6586L7.46406 14.08L12 19.4207L16.5359 14.08L15.147 12.6586Z"
      fill="rgba(111, 114, 126, 1)"
    />
  </svg>
</template>
